const dashboardCardIconHeaderSx = (theme) => ({
    icon: {
        fontSize: '32px',
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

export default dashboardCardIconHeaderSx;
